import styled from "styled-components";

export const Main = styled.main`
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`